import useRequest from '@/websdk/utils/request';
export default (function () {
  const { data } = useRequest({
    url: `/api/craft/spotcheck/config/defaultParam`,
    name: 'GET_SPOT_ALL',
    manual: false,
  });

  return data || [];
});
